import CustomScrollbar from '@r1-frontend/ui-react/components/CustomScrollbar';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FullWidthListContainer, IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { TListSize } from '@r1-frontend/ui-react/experimental/containers/ListContainer';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

interface IPopupState {
    isOpen: boolean,
    children: React.ReactNode,
    dPadding?: string,
    mPadding?: string,
    onClose: () => void,
}

const popupIndent = 64;
const desktopIndent = 32;
const mobileIndent = 24;
const scrollIndent = 12;
const desktopHeaderHeight = 56;
const mobileHeaderHeight = 44;
const popupHeight = `calc(100vh - ${popupIndent}px)`;
const desktopHeight = `calc(100vh - ${popupIndent + 2 * desktopIndent + desktopHeaderHeight }px)`;
const mobileHeight = `calc(100vh - ${popupIndent + 2 * mobileIndent + mobileHeaderHeight }px)`;

/**
 * Базовый попап подстроенный под кастомный скролл
 */
export const BasePopupWithScroll = ({
    isOpen,
    onClose,
    children,
}: IPopupState): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return (
        <DefaultPopup
            isOpen={isOpen}
            onClose={onClose}
            width={isMobile ? '352px' : '600px'}
            height={popupHeight}
            style={{ overflowY: 'visible' }}
        >
            <IndentContainer
                $desktop={[32, 20, 32, 32]}
                $mobile={[24, 12, 24, 24]}
            >
                {children}
            </IndentContainer>
        </DefaultPopup>
    );
};

interface IProps {
    children: JSX.Element | JSX.Element[],
    $desktop?: TListSize,
    $mobile?: TListSize,
}

/**
 * Компонент скрола
 */
export const TheScrollbar = ({ children, $desktop = 24, $mobile = 24 }: IProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return <CustomScrollbar
        customStyles={{
            view: {
                position: 'relative',
                paddingRight: `${scrollIndent}px`,
                paddingBottom: 0,
            },
        }}
    >
        <FullWidthListContainer
            $desktop={$desktop}
            $mobile={$mobile}
            style={{ maxHeight: isMobile ? mobileHeight : desktopHeight }}
        >
            {children}
        </FullWidthListContainer>
    </CustomScrollbar>;
};
